import { getResolvedPartition } from "./getResolvedPartition";
var AWS_TEMPLATE = "{signingService}.{region}.amazonaws.com";
export var getHostnameTemplate = function (region, _a) {
    var _b, _c;
    var signingService = _a.signingService, partitionHash = _a.partitionHash;
    return (_c = (_b = partitionHash[getResolvedPartition(region, { partitionHash: partitionHash })]) === null || _b === void 0 ? void 0 : _b.hostname) !== null && _c !== void 0 ? _c : AWS_TEMPLATE.replace("{signingService}", signingService);
};
